import { render } from "./ProfileCardDisplayer.vue?vue&type=template&id=56c07380&scoped=true"
import script from "./ProfileCardDisplayer.vue?vue&type=script&lang=js"
export * from "./ProfileCardDisplayer.vue?vue&type=script&lang=js"

import "./ProfileCardDisplayer.vue?vue&type=style&index=0&id=56c07380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c07380"]])

export default __exports__